﻿let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';

import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  Image,
  Dimensions,
  ActivityIndicator,
  Alert,
  Modal,
  Animated,
  TextInput,
  Share,
  FlatList,
  RefreshControl,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation, useRoute } from '@react-navigation/native';
import {


  Ionicons,
  MaterialIcons,
  FontAwesome,
  MaterialCommunityIcons,
  AntDesign,
} from '@expo/vector-icons';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const apiFetch = async (endpoint, options = {}) => {
  try {
    const response = await fetch(`${API_BASE}${endpoint}`, {
      headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY },
      ...options,
    });
    if (!response.ok) return { error: true, status: response.status };
    return await response.json();
  } catch (err) { return { error: true, message: err.message }; }
};


const { width, height } = Dimensions.get('window');

export default function ProfileRatingScreen() {
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_profileratingscreen`;
    apiFetch('/api/data/customers?limit=1').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  const navigation = useNavigation();
  const route = useRoute();

  // States
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('reviews'); // reviews, analytics, requests
  const [reviews, setReviews] = useState([]);
  const [overallRating, setOverallRating] = useState(0);
  const [categoryRatings, setCategoryRatings] = useState({});
  const [ratingTrends, setRatingTrends] = useState([]);
  const [showReviewDetail, setShowReviewDetail] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const [showResponseInput, setShowResponseInput] = useState(false);
  const [responseText, setResponseText] = useState('');
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [requestEmail, setRequestEmail] = useState('');
  const [filterType, setFilterType] = useState('all');

  // Profile stats + ATS snapshot (shown in header)
  const [profileStats, setProfileStats] = useState({ completionPercentage: 0 });
  const [atsScore, setAtsScore] = useState(null);
 // all, positive, negative, unanswered

  // Animation values
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const scaleAnim = useRef(new Animated.Value(0.9)).current;
  const ratingAnimations = useRef({}).current;

  // Sample data
  const sampleReviews = [
    {
      id: '1',
      employer: 'Atkins Global',
      employerLogo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=Atkins',
      reviewerName: 'Sarah Johnson',
      reviewerPosition: 'Project Manager',
      reviewerPhoto: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=SJ',
      date: '15 May 2025',
      project: 'Offshore Wind Turbine Design',
      overallRating: 4.8,
      categoryRatings: {
        'Technical Skills': 5.0,
        Communication: 4.5,
        'Problem Solving': 5.0,
        Reliability: 4.7,
        Teamwork: 4.8,
      },
      comment:
        'John demonstrated exceptional technical expertise in the offshore wind turbine project. His innovative approach to solving complex engineering challenges resulted in significant cost savings and improved efficiency. He communicated effectively with all team members and stakeholders, ensuring everyone was aligned with project goals. I would highly recommend John for any mechanical engineering role.',
      response: '',
      isResponsed: false,
      isHidden: false,
    },
    {
      id: '2',
      employer: 'Rolls-Royce',
      employerLogo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=RR',
      reviewerName: 'Michael Chen',
      reviewerPosition: 'Engineering Director',
      reviewerPhoto: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=MC',
      date: '28 April 2025',
      project: 'Turbine Component Optimization',
      overallRating: 4.5,
      categoryRatings: {
        'Technical Skills': 4.8,
        Communication: 4.2,
        'Problem Solving': 4.7,
        Reliability: 4.5,
        Teamwork: 4.3,
      },
      comment:
        'John s work on the turbine component optimization project was outstanding. He applied advanced engineering principles to improve component durability while reducing material costs. His analytical skills and attention to detail were particularly impressive. While his communication was generally good, there were occasions where more frequent updates would have been beneficial. Overall, a valuable team member who delivered excellent results.',
      response:
        'Thank you for your feedback, Michael. I appreciate your comments about my technical work and take note of your suggestion regarding more frequent communication. This is something Iam actively working to improve, and I value the opportunity to have worked with your team.',
      isResponsed: true,
      isHidden: false,
    },
    {
      id: '3',
      employer: 'BAE Systems',
      employerLogo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=BAE',
      reviewerName: 'Emma Wilson',
      reviewerPosition: 'Technical Lead',
      reviewerPhoto: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=EW',
      date: '10 March 2025',
      project: 'Defense System Component Design',
      overallRating: 3.9,
      categoryRatings: {
        'Technical Skills': 4.5,
        Communication: 3.2,
        'Problem Solving': 4.2,
        Reliability: 3.8,
        Teamwork: 3.8,
      },
      comment:
        'John has strong technical capabilities and produced high-quality designs for our defense system components. His problem-solving approach was methodical and effective. However, there were some challenges with meeting all deadlines and communication could have been more proactive, particularly when facing obstacles. With some improvement in project management and communication, John would be an exceptional engineer.',
      response: '',
      isResponsed: false,
      isHidden: false,
    },
    {
      id: '4',
      employer: 'Siemens Energy',
      employerLogo:
        'https://via.placeholder.com/100/0e4e96/FFFFFF?text=Siemens',
      reviewerName: 'David Rodriguez',
      reviewerPosition: 'Senior Manager',
      reviewerPhoto: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=DR',
      date: '5 February 2025',
      project: 'Power Generation Efficiency Improvement',
      overallRating: 4.9,
      categoryRatings: {
        'Technical Skills': 5.0,
        Communication: 4.8,
        'Problem Solving': 5.0,
        Reliability: 4.7,
        Teamwork: 5.0,
      },
      comment:
        'Working with John on our power generation efficiency project was a pleasure. He brought innovative ideas that led to a 7% improvement in system efficiency, exceeding our targets. His communication was clear and consistent, and he collaborated effectively with cross-functional teams. John has a rare combination of technical excellence and interpersonal skills that make him an asset to any engineering team.',
      response:
        'Thank you for the positive feedback, David. I enjoyed working on the power generation efficiency project and appreciated the collaborative environment at Siemens Energy. The challenging targets pushed me to develop innovative solutions, and Iam pleased that we exceeded the efficiency improvement goals.',
      isResponsed: true,
      isHidden: false,
    },
    {
      id: '5',
      employer: 'Dyson',
      employerLogo: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=Dyson',
      reviewerName: 'Lisa Thompson',
      reviewerPosition: 'Product Development Manager',
      reviewerPhoto: 'https://via.placeholder.com/100/0e4e96/FFFFFF?text=LT',
      date: '20 January 2025',
      project: 'Consumer Product Mechanical Design',
      overallRating: 4.6,
      categoryRatings: {
        'Technical Skills': 4.8,
        Communication: 4.5,
        'Problem Solving': 4.7,
        Reliability: 4.3,
        Teamwork: 4.7,
      },
      comment:
        'John contributed significantly to our consumer product development project. His mechanical design expertise helped us create a more efficient and user-friendly product. He was receptive to feedback and iterated designs quickly based on testing results. John worked well with our industrial designers to balance aesthetics with functionality. His work directly contributed to the success of the product launch.',
      response: '',
      isResponsed: false,
      isHidden: false,
    },
  ];

  const sampleRatingTrends = [
    { month: 'Jan', rating: 4.6 },
    { month: 'Feb', rating: 4.9 },
    { month: 'Mar', rating: 3.9 },
    { month: 'Apr', rating: 4.5 },
    { month: 'May', rating: 4.8 },
  ];

  // Load data
  useEffect(() => {
    // Load profile completion + ATS score for quick context (via service)
    (async () => {
      try {
        await ProfileManagementService.bootstrap();

        // 1. Get profile + completion percentage from the service
        const profileResult = await ProfileManagementService.getProfile();
        if (profileResult.success) {
          const completion = ProfileManagementService.getProfileCompletion(profileResult.data);
          setProfileStats({ completionPercentage: completion });
        } else {
          // Fall back to the legacy stats cache
          const statsRaw = await AsyncStorage.getItem(`professional_${_profUserId}_profileStats`);
          if (statsRaw) setProfileStats(JSON.parse(statsRaw));
        }

        // 2. Get cached ATS result if it exists (avoid re-running the server call
        //    here — there's a re-run button below for that)
        const atsCached = await AsyncStorage.getItem(`prof_${_profUserId}__ats_result`)
          || await AsyncStorage.getItem(`professional_${_profUserId}_atsResult`);
        if (atsCached) {
          const parsed = JSON.parse(atsCached);
          const score = typeof parsed?.score === 'number' ? parsed.score : parsed?.data?.score;
          if (typeof score === 'number') setAtsScore(score);
        }
      } catch (e) {
        // ignore — header context is non-essential
      }
    })();


    // Initialize rating animations
    const categories = [
      'Technical Skills',
      'Communication',
      'Problem Solving',
      'Reliability',
      'Teamwork',
    ];
    categories.forEach(category => {
      ratingAnimations[category] = new Animated.Value(0);
    });

    // Simulate API call
    setTimeout(() => {
      setReviews(sampleReviews);

      // Calculate overall rating
      const total = sampleReviews.reduce(
        (sum, review) => sum + review.overallRating,
        0
      );
      const average = total / sampleReviews.length;
      setOverallRating(average);

      // Calculate category ratings
      const categoryTotals = {};
      const categoryCounts = {};

      sampleReviews.forEach(review => {
        Object.entries(review.categoryRatings).forEach(([category, rating]) => {
          if (!categoryTotals[category]) {
            categoryTotals[category] = 0;
            categoryCounts[category] = 0;
          }
          categoryTotals[category] += rating;
          categoryCounts[category]++;
        });
      });

      const categoryAverages = {};
      Object.entries(categoryTotals).forEach(([category, total]) => {
        categoryAverages[category] = total / categoryCounts[category];
      });

      setCategoryRatings(categoryAverages);
      setRatingTrends(sampleRatingTrends);
      setIsLoading(false);
    }, 1500);
  }, []);

  // Re-run the ATS test against the current profile and update the header score.
  // Used by the "Refresh ATS" button in the ratings header.
  const reRunATS = async () => {
    try {
      const profileResult = await ProfileManagementService.getProfile();
      if (!profileResult.success) {
        Alert.alert('No profile data', 'Build your profile first to get an ATS score.');
        return;
      }
      const atsResult = await ProfileManagementService.runATSTest(profileResult.data);
      if (atsResult.success) {
        setAtsScore(atsResult.data.score);
        // Also refresh the AI recommendations cache for downstream consumers
        const completion = ProfileManagementService.getProfileCompletion(profileResult.data);
        await ProfileManagementService.buildAIRecommendationsFromATS(atsResult.data, {
          completionPercentage: completion,
        });
      } else {
        // Fall back to local score
        const local = ProfileManagementService.calculateLocalATSScore(profileResult.data);
        setAtsScore(local.score);
      }
    } catch (e) {
      console.warn('reRunATS:', e?.message);
    }
  };

  // Animation effects
  useEffect(() => {
    if (!isLoading) {
      // Fade in and scale up main content
      Animated.parallel([
        Animated.timing(fadeAnim, {
          toValue: 1,
          duration: 800,
          useNativeDriver: true,
        }),
        Animated.timing(scaleAnim, {
          toValue: 1,
          duration: 800,
          useNativeDriver: true,
        }),
      ]).start();

      // Animate category ratings
      const animations = Object.entries(categoryRatings).map(
        ([category, rating]) => {
          return Animated.timing(ratingAnimations[category], {
            toValue: rating / 5,
            duration: 1000,
            useNativeDriver: false,
          });
        }
      );

      Animated.stagger(100, animations).start();
    }
  }, [isLoading, fadeAnim, scaleAnim, categoryRatings]);

  // Filter reviews
  const getFilteredReviews = () => {
    switch (filterType) {
      case 'positive':
        return reviews.filter(
          review => review.overallRating >= 4.0 && !review.isHidden
        );
      case 'negative':
        return reviews.filter(
          review => review.overallRating < 4.0 && !review.isHidden
        );
      case 'unanswered':
        return reviews.filter(
          review => !review.isResponsed && !review.isHidden
        );
      default:
        return reviews.filter(review => !review.isHidden);
    }
  };

  // View review details
  const viewReviewDetails = review => {
    setSelectedReview(review);
    setShowReviewDetail(true);
  };

  // Respond to review
  const respondToReview = () => {
    if (!responseText.trim()) {
      Alert.alert('Error', 'Please enter a response before submitting.');
      return;
    }

    // Update review with response
    const updatedReviews = reviews.map(review => {
      if (review.id === selectedReview.id) {
        return {
          ...review,
          response: responseText,
          isResponsed: true,
        };
      }
      return review;
    });

    setReviews(updatedReviews);
    setSelectedReview({
      ...selectedReview,
      response: responseText,
      isResponsed: true,
    });
    setShowResponseInput(false);
    setResponseText('');

    Alert.alert('Success', 'Your response has been submitted.');
  };

  // Hide review
  const hideReview = () => {
    Alert.alert(
      'Hide Review',
      'Are you sure you want to hide this review? It will no longer be visible on your profile.',
      [
        {
          text: 'Cancel',
          style: 'cancel',
        },
        {
          text: 'Hide',
          onPress: () => {
            // Update review to hidden
            const updatedReviews = reviews.map(review => {
              if (review.id === selectedReview.id) {
                return {
                  ...review,
                  isHidden: true,
                };
              }
              return review;
            });

            setReviews(updatedReviews);
            setShowReviewDetail(false);
            Alert.alert(
              'Success',
              'The review has been hidden from your profile.'
            );
          },
        },
      ]
    );
  };

  // Report review
  const reportReview = () => {
    Alert.alert(
      'Report Review',
      'What is the reason for reporting this review?',
      [
        {
          text: 'Inappropriate Content',
          onPress: () => submitReport('Inappropriate Content'),
        },
        {
          text: 'Factually Incorrect',
          onPress: () => submitReport('Factually Incorrect'),
        },
        {
          text: 'Not Related to My Work',
          onPress: () => submitReport('Not Related to My Work'),
        },
        {
          text: 'Cancel',
          style: 'cancel',
        },
      ]
    );
  };

  // Submit report
  const submitReport = reason => {
    Alert.alert(
      'Report Submitted',
      `Your report for "${reason}" has been submitted. Our team will review it within 48 hours.`
    );
  };

  // Request new review
  const requestNewReview = () => {
    if (!requestEmail.trim() || !requestEmail.includes('@')) {
      Alert.alert('Error', 'Please enter a valid email address.');
      return;
    }

    // Simulate sending request
    setShowRequestModal(false);
    setRequestEmail('');
    Alert.alert(
      'Request Sent',
      `A review request has been sent to ${requestEmail}.`
    );
  };

  // Share profile ratings
  const shareRatings = async () => {
    try {
      await Share.share({
        message: `Check out my professional profile on JOBENG! I have an overall rating of ${overallRating.toFixed(1)}/5.0 from ${reviews.length} reviews.`,
        url: 'https://jobeng.ai/profile/john-engineer',
      });
    } catch (error) {
      Alert.alert('Error', 'Failed to share profile ratings.');
    }
  };

  // Render loading screen
  if (isLoading) {
    return (
      <SafeAreaView style={styles.safeArea}>
        <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />

        <View style={styles.header}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => navigation.goBack()}
          >
            <Ionicons name="arrow-back" size={24} color="#ffffff" />
          </TouchableOpacity>
          <Text style={styles.headerTitle}>Profile Ratings</Text>
          <View style={{ width: 32 }} />
        </View>


        {/* Quick Profile Context */}
        <View style={styles.contextBar}>
          <View style={styles.contextItem}>
            <Text style={styles.contextLabel}>Completion</Text>
            <Text style={styles.contextValue}>{Number(profileStats?.completionPercentage || 0)}%</Text>
            <View style={styles.contextProgress}>
              <View style={[styles.contextProgressFill, { width: `${Number(profileStats?.completionPercentage || 0)}%` }]} />
            </View>
          </View>

          <View style={styles.contextDivider} />

          <View style={styles.contextItem}>
            <Text style={styles.contextLabel}>ATS</Text>
            <Text style={styles.contextValue}>{typeof atsScore === 'number' ? atsScore : '--'}</Text>
            <Text style={styles.contextHint}>Score /100</Text>
          </View>
        </View>

        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#0e4e96" />
          <Text style={styles.loadingText}>Loading your ratings...</Text>
        </View>
      </SafeAreaView>
    );
  }

  // Render star rating
  const renderStarRating = (rating, size = 16, color = '#fdb913') => {
    const fullStars = Math.floor(rating);
    const halfStar = rating - fullStars >= 0.5;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

    return (
      <View style={styles.starContainer}>
        {[...Array(fullStars)].map((_, i) => (
          <FontAwesome
            key={`full-${i}`}
            name="star"
            size={size}
            color={color}
            style={styles.star}
          />
        ))}
        {halfStar && (
          <FontAwesome
            key="half"
            name="star-half-o"
            size={size}
            color={color}
            style={styles.star}
          />
        )}
        {[...Array(emptyStars)].map((_, i) => (
          <FontAwesome
            key={`empty-${i}`}
            name="star-o"
            size={size}
            color={color}
            style={styles.star}
          />
        ))}
      </View>
    );
  };

  // Render review card
  const renderReviewCard = ({ item }) => (
    <TouchableOpacity
      style={styles.reviewCard}
      onPress={() => viewReviewDetails(item)}
    >
      <View style={styles.reviewHeader}>
        <Image
          source={{ uri: (item.employerLogo && typeof item.employerLogo==='string' && item.employerLogo.startsWith('http')) ? item.employerLogo : undefined }}
          style={styles.employerLogo}
        />
        <View style={styles.reviewHeaderInfo}>
          <Text style={styles.employerName}>{item.employer}</Text>
          <Text style={styles.projectName}>{item.project}</Text>
        </View>
        <Text style={styles.reviewDate}>{item.date}</Text>
      </View>

      <View style={styles.reviewRating}>
        <Text style={styles.ratingNumber}>{item.overallRating.toFixed(1)}</Text>
        {renderStarRating(item.overallRating)}
      </View>

      <Text style={styles.reviewComment} numberOfLines={3}>
        {item.comment}
      </Text>

      <View style={styles.reviewFooter}>
        <View style={styles.reviewerInfo}>
          <Image
            source={{ uri: (item.reviewerPhoto && typeof item.reviewerPhoto==='string' && item.reviewerPhoto.startsWith('http')) ? item.reviewerPhoto : undefined }}
            style={styles.reviewerPhoto}
          />
          <View>
            <Text style={styles.reviewerName}>{item.reviewerName}</Text>
            <Text style={styles.reviewerPosition}>{item.reviewerPosition}</Text>
          </View>
        </View>

        {item.isResponsed ? (
          <View style={styles.respondedBadge}>
            <Ionicons name="checkmark-circle" size={14} color="#10B981" />
            <Text style={styles.respondedText}>Responded</Text>
          </View>
        ) : (
          <TouchableOpacity
            style={styles.respondButton}
            onPress={() => {
              setSelectedReview(item);
              setShowReviewDetail(true);
              setShowResponseInput(true);
            }}
          >
            <Text style={styles.respondButtonText}>Respond</Text>
          </TouchableOpacity>
        )}
      </View>
    </TouchableOpacity>
  );

  // Render category rating bar
  const renderCategoryRatingBar = (category, rating) => {
    const animatedWidth = ratingAnimations[category].interpolate({
      inputRange: [0, 1],
      outputRange: ['0%', '100%'],
    });

    return (
      <View style={styles.categoryRatingItem} key={category}>
        <View style={styles.categoryLabelContainer}>
          <Text style={styles.categoryLabel}>{category}</Text>
          <Text style={styles.categoryRatingValue}>{rating.toFixed(1)}</Text>
        </View>
        <View style={styles.categoryRatingBar}>
          <Animated.View
            style={[styles.categoryRatingFill, { width: animatedWidth }]}
          />
        </View>
      </View>
    );
  };

  // Render review detail modal
  const renderReviewDetailModal = () => (
    <Modal
      visible={showReviewDetail}
      transparent={true}
      animationType="slide"
      onRequestClose={() => {
        setShowReviewDetail(false);
        setShowResponseInput(false);
      }}
    >
      <View style={styles.modalContainer}>
        <View style={styles.modalContent}>
          <View style={styles.modalHeader}>
            <TouchableOpacity
              style={styles.modalCloseButton}
              onPress={() => {
                setShowReviewDetail(false);
                setShowResponseInput(false);
              }}
            >
              <Ionicons name="close" size={24} color="#0F172A" />
            </TouchableOpacity>
            <Text style={styles.modalTitle}>Review Details</Text>
            <View style={{ width: 24 }} />
          </View>

          {selectedReview && (
            <ScrollView style={styles.modalBody}>
              <View style={styles.detailReviewHeader}>
                <Image
                  source={{ uri: (selectedReview.employerLogo && typeof selectedReview.employerLogo=="string" && selectedReview.employerLogo.startsWith("http")) ? selectedReview.employerLogo : undefined }}
                  style={styles.detailEmployerLogo}
                />
                <View style={styles.detailReviewHeaderInfo}>
                  <Text style={styles.detailEmployerName}>
                    {selectedReview.employer}
                  </Text>
                  <Text style={styles.detailProjectName}>
                    {selectedReview.project}
                  </Text>
                  <Text style={styles.detailReviewDate}>
                    {selectedReview.date}
                  </Text>
                </View>
              </View>

              <View style={styles.detailReviewRating}>
                <Text style={styles.detailRatingNumber}>
                  {selectedReview.overallRating.toFixed(1)}
                </Text>
                {renderStarRating(selectedReview.overallRating, 20)}
              </View>

              <View style={styles.detailCategoryRatings}>
                <Text style={styles.detailSectionTitle}>Rating Breakdown</Text>
                {Object.entries(selectedReview.categoryRatings).map(
                  ([category, rating]) => (
                    <View
                      style={styles.detailCategoryRatingItem}
                      key={category}
                    >
                      <Text style={styles.detailCategoryLabel}>{category}</Text>
                      <View style={styles.detailCategoryRatingValue}>
                        <Text style={styles.detailCategoryRatingNumber}>
                          {rating.toFixed(1)}
                        </Text>
                        {renderStarRating(rating, 14)}
                      </View>
                    </View>
                  )
                )}
              </View>

              <View style={styles.detailReviewComment}>
                <Text style={styles.detailSectionTitle}>Review</Text>
                <Text style={styles.detailCommentText}>
                  {selectedReview.comment}
                </Text>
              </View>

              <View style={styles.detailReviewerInfo}>
                <Image
                  source={{ uri: (selectedReview.reviewerPhoto && typeof selectedReview.reviewerPhoto=="string" && selectedReview.reviewerPhoto.startsWith("http")) ? selectedReview.reviewerPhoto : undefined }}
                  style={styles.detailReviewerPhoto}
                />
                <View>
                  <Text style={styles.detailReviewerName}>
                    {selectedReview.reviewerName}
                  </Text>
                  <Text style={styles.detailReviewerPosition}>
                    {selectedReview.reviewerPosition}
                  </Text>
                </View>
              </View>

              {selectedReview.isResponsed && (
                <View style={styles.detailResponseContainer}>
                  <Text style={styles.detailSectionTitle}>Your Response</Text>
                  <View style={styles.detailResponseContent}>
                    <Text style={styles.detailResponseText}>
                      {selectedReview.response}
                    </Text>
                  </View>
                </View>
              )}

              {showResponseInput ? (
                <View style={styles.responseInputContainer}>
                  <Text style={styles.detailSectionTitle}>Your Response</Text>
                  <TextInput
                    style={styles.responseInput}
                    placeholder="Write your response to this review..."
                    multiline
                    value={responseText}
                    onChangeText={setResponseText}
                  />
                  <View style={styles.responseButtonsContainer}>
                    <TouchableOpacity
                      style={styles.cancelResponseButton}
                      onPress={() => setShowResponseInput(false)}
                    >
                      <Text style={styles.cancelResponseButtonText}>
                        Cancel
                      </Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={styles.submitResponseButton}
                      onPress={respondToReview}
                    >
                      <Text style={styles.submitResponseButtonText}>
                        Submit Response
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              ) : (
                !selectedReview.isResponsed && (
                  <TouchableOpacity
                    style={styles.addResponseButton}
                    onPress={() => setShowResponseInput(true)}
                  >
                    <Ionicons
                      name="chatbubble-outline"
                      size={18}
                      color="#ffffff"
                    />
                    <Text style={styles.addResponseButtonText}>
                      Add Response
                    </Text>
                  </TouchableOpacity>
                )
              )}

              <View style={styles.detailActionButtons}>
                <TouchableOpacity
                  style={styles.detailActionButton}
                  onPress={hideReview}
                >
                  <Ionicons name="eye-off-outline" size={18} color="#64748B" />
                  <Text style={styles.detailActionButtonText}>Hide</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.detailActionButton}
                  onPress={reportReview}
                >
                  <Ionicons name="flag-outline" size={18} color="#64748B" />
                  <Text style={styles.detailActionButtonText}>Report</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.detailActionButton}
                  onPress={shareRatings}
                >
                  <Ionicons name="share-outline" size={18} color="#64748B" />
                  <Text style={styles.detailActionButtonText}>Share</Text>
                </TouchableOpacity>
              </View>
            </ScrollView>
          )}
        </View>
      </View>
    </Modal>
  );

  // Render request review modal
  const renderRequestReviewModal = () => (
    <Modal
      visible={showRequestModal}
      transparent={true}
      animationType="fade"
      onRequestClose={() => setShowRequestModal(false)}
    >
      <View style={styles.modalContainer}>
        <View style={styles.requestModalContent}>
          <View style={styles.modalHeader}>
            <TouchableOpacity
              style={styles.modalCloseButton}
              onPress={() => setShowRequestModal(false)}
            >
              <Ionicons name="close" size={24} color="#0F172A" />
            </TouchableOpacity>
            <Text style={styles.modalTitle}>Request Review</Text>
            <View style={{ width: 24 }} />
          </View>

          <View style={styles.requestModalBody}>
            <Text style={styles.requestModalText}>
              Send a review request to your employer or client. They will
              receive an email with a link to leave a review on your profile.
            </Text>

            <View style={styles.requestInputContainer}>
              <Text style={styles.requestInputLabel}>
                Employer/Client Email
              </Text>
              <TextInput
                style={styles.requestInput}
                placeholder="Enter email address"
                value={requestEmail}
                onChangeText={setRequestEmail}
                keyboardType="email-address"
                autoCapitalize="none"
              />
            </View>

            <TouchableOpacity
              style={styles.sendRequestButton}
              onPress={requestNewReview}
            >
              <Text style={styles.sendRequestButtonText}>Send Request</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );

  // Render reviews tab
  const renderReviewsTab = () => (
    <View style={styles.tabContent}>
      <View style={styles.filterContainer}>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={styles.filterScrollContent}
        >
          <TouchableOpacity
            style={[
              styles.filterButton,
              filterType === 'all' && styles.filterButtonActive,
            ]}
            onPress={() => setFilterType('all')}
          >
            <Text
              style={[
                styles.filterButtonText,
                filterType === 'all' && styles.filterButtonTextActive,
              ]}
            >
              All Reviews
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={[
              styles.filterButton,
              filterType === 'positive' && styles.filterButtonActive,
            ]}
            onPress={() => setFilterType('positive')}
          >
            <Text
              style={[
                styles.filterButtonText,
                filterType === 'positive' && styles.filterButtonTextActive,
              ]}
            >
              Positive
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={[
              styles.filterButton,
              filterType === 'negative' && styles.filterButtonActive,
            ]}
            onPress={() => setFilterType('negative')}
          >
            <Text
              style={[
                styles.filterButtonText,
                filterType === 'negative' && styles.filterButtonTextActive,
              ]}
            >
              Needs Improvement
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={[
              styles.filterButton,
              filterType === 'unanswered' && styles.filterButtonActive,
            ]}
            onPress={() => setFilterType('unanswered')}
          >
            <Text
              style={[
                styles.filterButtonText,
                filterType === 'unanswered' && styles.filterButtonTextActive,
              ]}
            >
              Unanswered
            </Text>
          </TouchableOpacity>
        </ScrollView>
      </View>

      <FlatList
        data={getFilteredReviews()}
        renderItem={renderReviewCard}
        keyExtractor={item => item.id}
        contentContainerStyle={styles.reviewsList}
        showsVerticalScrollIndicator={false}
        ListEmptyComponent={
          <View style={styles.emptyReviewsContainer}>
            <Ionicons name="document-text-outline" size={60} color="#CBD5E1" />
            <Text style={styles.emptyReviewsText}>No reviews found</Text>
            <Text style={styles.emptyReviewsSubtext}>
              {filterType === 'all'
                ? 'You have no reviews yet. Request reviews from your employers or clients.'
                : `No ${filterType} reviews found. Try a different filter.`}
            </Text>
          </View>
        }
      />
    </View>
  );

  // Render analytics tab
  const renderAnalyticsTab = () => {
    return (
      <ScrollView
        style={styles.tabContent}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.analyticsSection}>
          <Text style={styles.analyticsSectionTitle}>Rating Trend</Text>
          <Text style={styles.analyticsSectionSubtitle}>
            How your ratings have changed over time
          </Text>

          <View style={styles.customChartContainer}>
            {/* Custom line chart using basic React Native components */}
            <View style={styles.customLineChart}>
              <View style={styles.customLineChartYAxis}>
                {[5, 4, 3, 2, 1].map(value => (
                  <Text
                    key={`y-${value}`}
                    style={styles.customLineChartAxisLabel}
                  >
                    {value}
                  </Text>
                ))}
              </View>

              <View style={styles.customLineChartContent}>
                <View style={styles.customLineChartGrid}>
                  {[5, 4, 3, 2, 1].map(value => (
                    <View
                      key={`grid-${value}`}
                      style={styles.customLineChartGridLine}
                    />
                  ))}
                </View>

                <View style={styles.customLineChartLines}>
                  {ratingTrends.map((item, index) => {
                    if (index === ratingTrends.length - 1) return null;

                    const startHeight = (item.rating / 5) * 180;
                    const endHeight =
                      (ratingTrends[index + 1].rating / 5) * 180;

                    return (
                      <View
                        key={`line-${index}`}
                        style={[
                          styles.customLineChartLine,
                          {
                            left: `${(index / (ratingTrends.length - 1)) * 100}%`,
                            height: Math.abs(endHeight - startHeight),
                            top: 180 - Math.max(startHeight, endHeight),
                            width: `${100 / (ratingTrends.length - 1)}%`,
                            transform: [
                              {
                                skewY:
                                  startHeight > endHeight ? '45deg' : '-45deg',
                              },
                            ],
                          },
                        ]}
                      />
                    );
                  })}
                </View>

                <View style={styles.customLineChartDots}>
                  {ratingTrends.map((item, index) => {
                    const dotHeight = (item.rating / 5) * 180;

                    return (
                      <View
                        key={`dot-${index}`}
                        style={[
                          styles.customLineChartDot,
                          {
                            left: `${(index / (ratingTrends.length - 1)) * 100}%`,
                            bottom: dotHeight,
                          },
                        ]}
                      />
                    );
                  })}
                </View>
              </View>
            </View>

            <View style={styles.customLineChartXAxis}>
              {ratingTrends.map((item, index) => (
                <Text
                  key={`x-${index}`}
                  style={[
                    styles.customLineChartAxisLabel,
                    {
                      left: `${(index / (ratingTrends.length - 1)) * 100}%`,
                      transform: [{ translateX: -15 }],
                    },
                  ]}
                >
                  {item.month}
                </Text>
              ))}
            </View>
          </View>
        </View>

        <View style={styles.analyticsSection}>
          <Text style={styles.analyticsSectionTitle}>Rating Distribution</Text>
          <Text style={styles.analyticsSectionSubtitle}>
            Breakdown of your ratings by stars
          </Text>

          <View style={styles.customChartContainer}>
            {/* Custom pie chart using basic React Native components */}
            <View style={styles.customPieChart}>
              <View style={styles.customPieChartLegend}>
                {[
                  {
                    label: '5 Stars',
                    color: '#10B981',
                    count: reviews.filter(r => r.overallRating >= 4.5).length,
                  },
                  {
                    label: '4 Stars',
                    color: '#0e4e96',
                    count: reviews.filter(
                      r => r.overallRating >= 3.5 && r.overallRating < 4.5
                    ).length,
                  },
                  {
                    label: '3 Stars',
                    color: '#fdb913',
                    count: reviews.filter(
                      r => r.overallRating >= 2.5 && r.overallRating < 3.5
                    ).length,
                  },
                  {
                    label: '2 Stars',
                    color: '#F97316',
                    count: reviews.filter(
                      r => r.overallRating >= 1.5 && r.overallRating < 2.5
                    ).length,
                  },
                  {
                    label: '1 Star',
                    color: '#EF4444',
                    count: reviews.filter(r => r.overallRating < 1.5).length,
                  },
                ]
                  .filter(item => item.count > 0)
                  .map((item, index) => (
                    <View
                      key={`legend-${index}`}
                      style={styles.customPieChartLegendItem}
                    >
                      <View
                        style={[
                          styles.customPieChartLegendColor,
                          { backgroundColor: item.color },
                        ]}
                      />
                      <Text style={styles.customPieChartLegendLabel}>
                        {item.label}
                      </Text>
                      <Text style={styles.customPieChartLegendCount}>
                        {item.count}
                      </Text>
                    </View>
                  ))}
              </View>

              <View style={styles.customPieChartContent}>
                {/* Simplified pie chart representation using horizontal bars */}
                {[
                  {
                    label: '5 Stars',
                    color: '#10B981',
                    count: reviews.filter(r => r.overallRating >= 4.5).length,
                  },
                  {
                    label: '4 Stars',
                    color: '#0e4e96',
                    count: reviews.filter(
                      r => r.overallRating >= 3.5 && r.overallRating < 4.5
                    ).length,
                  },
                  {
                    label: '3 Stars',
                    color: '#fdb913',
                    count: reviews.filter(
                      r => r.overallRating >= 2.5 && r.overallRating < 3.5
                    ).length,
                  },
                  {
                    label: '2 Stars',
                    color: '#F97316',
                    count: reviews.filter(
                      r => r.overallRating >= 1.5 && r.overallRating < 2.5
                    ).length,
                  },
                  {
                    label: '1 Star',
                    color: '#EF4444',
                    count: reviews.filter(r => r.overallRating < 1.5).length,
                  },
                ]
                  .filter(item => item.count > 0)
                  .map((item, index) => {
                    const percentage = (item.count / reviews.length) * 100;

                    return (
                      <View
                        key={`bar-${index}`}
                        style={styles.customPieChartBar}
                      >
                        <View style={styles.customPieChartBarLabel}>
                          <Text style={styles.customPieChartBarLabelText}>
                            {item.label}
                          </Text>
                        </View>
                        <View style={styles.customPieChartBarContainer}>
                          <View
                            style={[
                              styles.customPieChartBarFill,
                              {
                                width: `${percentage}%`,
                                backgroundColor: item.color,
                              },
                            ]}
                          />
                          <Text style={styles.customPieChartBarPercentage}>
                            {Math.round(percentage)}%
                          </Text>
                        </View>
                      </View>
                    );
                  })}
              </View>
            </View>
          </View>
        </View>

        <View style={styles.analyticsSection}>
          <Text style={styles.analyticsSectionTitle}>Skill Performance</Text>
          <Text style={styles.analyticsSectionSubtitle}>
            How you rate across different skills
          </Text>

          <View style={styles.categoryRatingsContainer}>
            {Object.entries(categoryRatings).map(([category, rating]) =>
              renderCategoryRatingBar(category, rating)
            )}
          </View>
        </View>

        <View style={styles.analyticsSection}>
          <Text style={styles.analyticsSectionTitle}>Response Rate</Text>
          <Text style={styles.analyticsSectionSubtitle}>
            How often you respond to reviews
          </Text>

          <View style={styles.responseRateContainer}>
            <View style={styles.responseRateCircle}>
              <Text style={styles.responseRatePercentage}>
                {Math.round(
                  (reviews.filter(r => r.isResponsed).length / reviews.length) *
                    100
                )}
                %
              </Text>
            </View>
            <View style={styles.responseRateInfo}>
              <View style={styles.responseRateItem}>
                <Text style={styles.responseRateLabel}>Responded</Text>
                <Text style={styles.responseRateValue}>
                  {reviews.filter(r => r.isResponsed).length}
                </Text>
              </View>
              <View style={styles.responseRateItem}>
                <Text style={styles.responseRateLabel}>Pending</Text>
                <Text style={styles.responseRateValue}>
                  {reviews.filter(r => !r.isResponsed).length}
                </Text>
              </View>
              <View style={styles.responseRateItem}>
                <Text style={styles.responseRateLabel}>Total</Text>
                <Text style={styles.responseRateValue}>{reviews.length}</Text>
              </View>
            </View>
          </View>
        </View>

        <View style={styles.analyticsSection}>
          <Text style={styles.analyticsSectionTitle}>Improvement Areas</Text>
          <Text style={styles.analyticsSectionSubtitle}>
            Skills that could use improvement based on reviews
          </Text>

          <View style={styles.improvementAreasContainer}>
            {Object.entries(categoryRatings)
              .sort(([, a], [, b]) => a - b)
              .slice(0, 3)
              .map(([category, rating]) => (
                <View style={styles.improvementAreaItem} key={category}>
                  <View style={styles.improvementAreaHeader}>
                    <Text style={styles.improvementAreaCategory}>
                      {category}
                    </Text>
                    <View style={styles.improvementAreaRating}>
                      <Text style={styles.improvementAreaRatingValue}>
                        {rating.toFixed(1)}
                      </Text>
                      {renderStarRating(rating, 12)}
                    </View>
                  </View>
                  <View style={styles.improvementAreaBar}>
                    <View
                      style={[
                        styles.improvementAreaFill,
                        { width: `${(rating / 5) * 100}%` },
                      ]}
                    />
                  </View>
                  <Text style={styles.improvementAreaTip}>
                    {category === 'Communication' &&
                      'Consider more frequent updates and clearer documentation.'}
                    {category === 'Reliability' &&
                      'Focus on meeting all deadlines and setting realistic expectations.'}
                    {category === 'Teamwork' &&
                      'Engage more actively in team discussions and collaborative problem-solving.'}
                    {category === 'Problem Solving' &&
                      'Develop a more structured approach to complex challenges.'}
                    {category === 'Technical Skills' &&
                      'Consider additional training or certification in specific technical areas.'}
                  </Text>
                </View>
              ))}
          </View>
        </View>
      </ScrollView>
    );
  };

  // Render requests tab
  const renderRequestsTab = () => (
    <View style={styles.tabContent}>
      <View style={styles.requestsContainer}>
        <View style={styles.requestsHeader}>
          <Text style={styles.requestsTitle}>Review Requests</Text>
          <TouchableOpacity
            style={styles.newRequestButton}
            onPress={() => setShowRequestModal(true)}
          >
            <Ionicons name="add" size={20} color="#ffffff" />
            <Text style={styles.newRequestButtonText}>New Request</Text>
          </TouchableOpacity>
        </View>

        <View style={styles.requestsInfo}>
          <Ionicons
            name="information-circle-outline"
            size={20}
            color="#64748B"
          />
          <Text style={styles.requestsInfoText}>
            Request reviews from employers or clients you've worked with.
            They'll receive an email with a link to leave a review on your
            profile.
          </Text>
        </View>

        <View style={styles.requestsListContainer}>
          <Text style={styles.requestsListTitle}>Recent Requests</Text>

          <View style={styles.requestItem}>
            <View style={styles.requestItemIcon}>
              <Ionicons name="mail-outline" size={24} color="#0e4e96" />
            </View>
            <View style={styles.requestItemContent}>
              <Text style={styles.requestItemEmail}>
                david.rodriguez@siemens.com
              </Text>
              <Text style={styles.requestItemDate}>Sent on 10 May 2025</Text>
              <View style={styles.requestItemStatus}>
                <View style={styles.requestItemStatusDot} />
                <Text style={styles.requestItemStatusText}>Completed</Text>
              </View>
            </View>
          </View>

          <View style={styles.requestItem}>
            <View style={styles.requestItemIcon}>
              <Ionicons name="mail-outline" size={24} color="#0e4e96" />
            </View>
            <View style={styles.requestItemContent}>
              <Text style={styles.requestItemEmail}>
                emma.wilson@baesystems.com
              </Text>
              <Text style={styles.requestItemDate}>Sent on 5 May 2025</Text>
              <View style={styles.requestItemStatus}>
                <View style={styles.requestItemStatusDot} />
                <Text style={styles.requestItemStatusText}>Completed</Text>
              </View>
            </View>
          </View>

          <View style={styles.requestItem}>
            <View style={styles.requestItemIcon}>
              <Ionicons name="mail-outline" size={24} color="#0e4e96" />
            </View>
            <View style={styles.requestItemContent}>
              <Text style={styles.requestItemEmail}>
                james.thompson@dyson.com
              </Text>
              <Text style={styles.requestItemDate}>Sent on 1 May 2025</Text>
              <View
                style={[
                  styles.requestItemStatus,
                  styles.requestItemStatusPending,
                ]}
              >
                <View
                  style={[
                    styles.requestItemStatusDot,
                    styles.requestItemStatusDotPending,
                  ]}
                />
                <Text
                  style={[
                    styles.requestItemStatusText,
                    styles.requestItemStatusTextPending,
                  ]}
                >
                  Pending
                </Text>
              </View>
            </View>
            <TouchableOpacity style={styles.requestItemRemind}>
              <Text style={styles.requestItemRemindText}>Remind</Text>
            </TouchableOpacity>
          </View>
        </View>

        <View style={styles.requestTemplateContainer}>
          <Text style={styles.requestTemplateTitle}>Request Template</Text>
          <Text style={styles.requestTemplateSubtitle}>
            Customize the message sent to employers or clients when requesting
            reviews.
          </Text>

          <View style={styles.requestTemplatePreview}>
            <Text style={styles.requestTemplatePreviewText}>
              Hello,{'\n\n'}I hope this message finds you well. I'm reaching out
              to request a review of my work on the recent project we completed
              together. Your feedback is valuable to me and helps potential
              employers understand my skills and work ethic.{'\n\n'}
              You can leave a review by clicking the link below:{'\n'}
              [Review Link]{'\n\n'}
              Thank you for your time and consideration.{'\n\n'}
              Best regards,{'\n'}
              John Engineer
            </Text>
          </View>

          <TouchableOpacity style={styles.editTemplateButton}>
            <Text style={styles.editTemplateButtonText}>Edit Template</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />

      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="arrow-back" size={24} color="#ffffff" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Profile Ratings</Text>
        <TouchableOpacity style={styles.shareButton} onPress={shareRatings}>
          <Ionicons name="share-outline" size={24} color="#ffffff" />
        </TouchableOpacity>
      </View>

      <Animated.View
        style={[
          styles.ratingOverview,
          {
            opacity: fadeAnim,
            transform: [{ scale: scaleAnim }],
          },
        ]}
      >
        <View style={styles.overallRatingContainer}>
          <Text style={styles.overallRatingNumber}>
            {overallRating.toFixed(1)}
          </Text>
          <View style={styles.overallRatingStars}>
            {renderStarRating(overallRating, 24)}
            <Text style={styles.overallRatingCount}>
              {reviews.length} {reviews.length === 1 ? 'review' : 'reviews'}
            </Text>
          </View>
        </View>

        <View style={styles.ratingBreakdownContainer}>
          {Object.entries(categoryRatings)
            .sort(([a], [b]) => a.localeCompare(b))
            .slice(0, 3)
            .map(([category, rating]) => (
              <View style={styles.ratingBreakdownItem} key={category}>
                <Text style={styles.ratingBreakdownLabel}>{category}</Text>
                <View style={styles.ratingBreakdownBar}>
                  <Animated.View
                    style={[
                      styles.ratingBreakdownFill,
                      {
                        width: ratingAnimations[category].interpolate({
                          inputRange: [0, 1],
                          outputRange: ['0%', '100%'],
                        }),
                      },
                    ]}
                  />
                </View>
                <Text style={styles.ratingBreakdownValue}>
                  {rating.toFixed(1)}
                </Text>
              </View>
            ))}
        </View>
      </Animated.View>

      <View style={styles.tabsContainer}>
        <TouchableOpacity
          style={[
            styles.tabButton,
            activeTab === 'reviews' && styles.activeTabButton,
          ]}
          onPress={() => setActiveTab('reviews')}
        >
          <Ionicons
            name="star"
            size={20}
            color={activeTab === 'reviews' ? '#0e4e96' : '#64748B'}
          />
          <Text
            style={[
              styles.tabButtonText,
              activeTab === 'reviews' && styles.activeTabButtonText,
            ]}
          >
            Reviews
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[
            styles.tabButton,
            activeTab === 'analytics' && styles.activeTabButton,
          ]}
          onPress={() => setActiveTab('analytics')}
        >
          <Ionicons
            name="analytics"
            size={20}
            color={activeTab === 'analytics' ? '#0e4e96' : '#64748B'}
          />
          <Text
            style={[
              styles.tabButtonText,
              activeTab === 'analytics' && styles.activeTabButtonText,
            ]}
          >
            Analytics
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[
            styles.tabButton,
            activeTab === 'requests' && styles.activeTabButton,
          ]}
          onPress={() => setActiveTab('requests')}
        >
          <Ionicons
            name="mail"
            size={20}
            color={activeTab === 'requests' ? '#0e4e96' : '#64748B'}
          />
          <Text
            style={[
              styles.tabButtonText,
              activeTab === 'requests' && styles.activeTabButtonText,
            ]}
          >
            Requests
          </Text>
        </TouchableOpacity>
      </View>

      <View style={styles.tabContentContainer}>
        {activeTab === 'reviews' && renderReviewsTab()}
        {activeTab === 'analytics' && renderAnalyticsTab()}
        {activeTab === 'requests' && renderRequestsTab()}
      </View>

      {activeTab === 'reviews' && (
        <TouchableOpacity
          style={styles.floatingButton}
          onPress={() => setShowRequestModal(true)}
        >
          <Ionicons name="add" size={24} color="#ffffff" />
        </TouchableOpacity>
      )}

      {renderReviewDetailModal()}
      {renderRequestReviewModal()}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#F8FAFC',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#0e4e96',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  backButton: {
    padding: 8,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#ffffff',
  },
  shareButton: {
    padding: 8,
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingText: {
    fontSize: 16,
    color: '#64748B',
    marginTop: 16,
  },

  // Rating Overview
  ratingOverview: {
    backgroundColor: '#ffffff',
    paddingHorizontal: 16,
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  overallRatingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  overallRatingNumber: {
    fontSize: 48,
    fontWeight: '700',
    color: '#0F172A',
    marginRight: 16,
  },
  overallRatingStars: {
    flex: 1,
  },
  overallRatingCount: {
    fontSize: 14,
    color: '#64748B',
    marginTop: 4,
  },
  starContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  star: {
    marginRight: 2,
  },
  ratingBreakdownContainer: {
    marginTop: 8,
  },
  ratingBreakdownItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  ratingBreakdownLabel: {
    width: 120,
    fontSize: 14,
    color: '#0F172A',
  },
  ratingBreakdownBar: {
    flex: 1,
    height: 8,
    backgroundColor: '#E2E8F0',
    borderRadius: 4,
    marginHorizontal: 8,
    overflow: 'hidden',
  },
  ratingBreakdownFill: {
    height: '100%',
    backgroundColor: '#0e4e96',
    borderRadius: 4,
  },
  ratingBreakdownValue: {
    width: 30,
    fontSize: 14,
    fontWeight: '600',
    color: '#0F172A',
    textAlign: 'right',
  },

  // Tabs
  tabsContainer: {
    flexDirection: 'row',
    backgroundColor: '#ffffff',
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  tabButton: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
  },
  activeTabButton: {
    borderBottomWidth: 2,
    borderBottomColor: '#0e4e96',
  },
  tabButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#64748B',
    marginLeft: 6,
  },
  activeTabButtonText: {
    color: '#0e4e96',
  },
  tabContentContainer: {
    flex: 1,
  },
  tabContent: {
    flex: 1,
  },

  // Reviews Tab
  filterContainer: {
    backgroundColor: '#ffffff',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  filterScrollContent: {
    paddingHorizontal: 16,
  },
  filterButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 20,
    backgroundColor: '#F1F5F9',
    marginRight: 8,
  },
  filterButtonActive: {
    backgroundColor: '#0e4e96',
  },
  filterButtonText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#64748B',
  },
  filterButtonTextActive: {
    color: '#ffffff',
  },
  reviewsList: {
    padding: 16,
    paddingBottom: 80,
  },
  reviewCard: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  reviewHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  employerLogo: {
    width: 40,
    height: 40,
    borderRadius: 8,
    marginRight: 12,
  },
  reviewHeaderInfo: {
    flex: 1,
  },
  employerName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 2,
  },
  projectName: {
    fontSize: 14,
    color: '#64748B',
  },
  reviewDate: {
    fontSize: 12,
    color: '#94A3B8',
  },
  reviewRating: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  ratingNumber: {
    fontSize: 18,
    fontWeight: '700',
    color: '#0F172A',
    marginRight: 8,
  },
  reviewComment: {
    fontSize: 14,
    color: '#334155',
    lineHeight: 20,
    marginBottom: 12,
  },
  reviewFooter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  reviewerInfo: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  reviewerPhoto: {
    width: 32,
    height: 32,
    borderRadius: 16,
    marginRight: 8,
  },
  reviewerName: {
    fontSize: 14,
    fontWeight: '500',
    color: '#0F172A',
  },
  reviewerPosition: {
    fontSize: 12,
    color: '#64748B',
  },
  respondedBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#ECFDF5',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  respondedText: {
    fontSize: 12,
    color: '#10B981',
    marginLeft: 4,
  },
  respondButton: {
    backgroundColor: '#0e4e96',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
  },
  respondButtonText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#ffffff',
  },
  emptyReviewsContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 40,
  },
  emptyReviewsText: {
    fontSize: 18,
    fontWeight: '600',
    color: '#0F172A',
    marginTop: 16,
    marginBottom: 8,
  },
  emptyReviewsSubtext: {
    fontSize: 14,
    color: '#64748B',
    textAlign: 'center',
    lineHeight: 20,
  },

  // Analytics Tab
  analyticsSection: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 16,
    marginHorizontal: 16,
    marginTop: 16,
    marginBottom: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  analyticsSectionTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#0F172A',
    marginBottom: 4,
  },
  analyticsSectionSubtitle: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 16,
  },

  // Custom Charts
  customChartContainer: {
    marginVertical: 16,
  },

  // Custom Line Chart
  customLineChart: {
    height: 200,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  customLineChartYAxis: {
    width: 30,
    height: 200,
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingRight: 8,
  },
  customLineChartAxisLabel: {
    fontSize: 12,
    color: '#64748B',
  },
  customLineChartContent: {
    flex: 1,
    height: 200,
    position: 'relative',
  },
  customLineChartGrid: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  customLineChartGridLine: {
    position: 'absolute',
    left: 0,
    right: 0,
    height: 1,
    backgroundColor: '#E2E8F0',
  },
  customLineChartLines: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  customLineChartLine: {
    position: 'absolute',
    backgroundColor: '#0e4e96',
    height: 2,
  },
  customLineChartDots: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  customLineChartDot: {
    position: 'absolute',
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#0e4e96',
    marginLeft: -4,
    marginBottom: -4,
  },
  customLineChartXAxis: {
    height: 20,
    flexDirection: 'row',
    position: 'relative',
  },

  // Custom Pie Chart
  customPieChart: {
    flexDirection: 'row',
    marginVertical: 16,
  },
  customPieChartLegend: {
    width: 120,
  },
  customPieChartLegendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  customPieChartLegendColor: {
    width: 12,
    height: 12,
    borderRadius: 6,
    marginRight: 8,
  },
  customPieChartLegendLabel: {
    fontSize: 12,
    color: '#0F172A',
    flex: 1,
  },
  customPieChartLegendCount: {
    fontSize: 12,
    fontWeight: '600',
    color: '#0F172A',
  },
  customPieChartContent: {
    flex: 1,
  },
  customPieChartBar: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  customPieChartBarLabel: {
    width: 60,
  },
  customPieChartBarLabelText: {
    fontSize: 12,
    color: '#64748B',
  },
  customPieChartBarContainer: {
    flex: 1,
    height: 20,
    backgroundColor: '#F1F5F9',
    borderRadius: 4,
    overflow: 'hidden',
    position: 'relative',
  },
  customPieChartBarFill: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    borderRadius: 4,
  },
  customPieChartBarPercentage: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    textAlign: 'center',
    textAlignVertical: 'center',
    fontSize: 12,
    fontWeight: '600',
    color: '#ffffff',
  },

  categoryRatingsContainer: {
    marginTop: 8,
  },
  categoryRatingItem: {
    marginBottom: 12,
  },
  categoryLabelContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  categoryLabel: {
    fontSize: 14,
    color: '#0F172A',
  },
  categoryRatingValue: {
    fontSize: 14,
    fontWeight: '600',
    color: '#0F172A',
  },
  categoryRatingBar: {
    height: 8,
    backgroundColor: '#E2E8F0',
    borderRadius: 4,
    overflow: 'hidden',
  },
  categoryRatingFill: {
    height: '100%',
    backgroundColor: '#0e4e96',
    borderRadius: 4,
  },
  responseRateContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 8,
  },
  responseRateCircle: {
    width: 100,
    height: 100,
    borderRadius: 50,
    backgroundColor: '#E0F2FE',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 16,
  },
  responseRatePercentage: {
    fontSize: 24,
    fontWeight: '700',
    color: '#0e4e96',
  },
  responseRateInfo: {
    flex: 1,
  },
  responseRateItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  responseRateLabel: {
    fontSize: 14,
    color: '#64748B',
  },
  responseRateValue: {
    fontSize: 14,
    fontWeight: '600',
    color: '#0F172A',
  },
  improvementAreasContainer: {
    marginTop: 8,
  },
  improvementAreaItem: {
    backgroundColor: '#F8FAFC',
    borderRadius: 8,
    padding: 12,
    marginBottom: 12,
  },
  improvementAreaHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  improvementAreaCategory: {
    fontSize: 14,
    fontWeight: '600',
    color: '#0F172A',
  },
  improvementAreaRating: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  improvementAreaRatingValue: {
    fontSize: 14,
    fontWeight: '600',
    color: '#0F172A',
    marginRight: 4,
  },
  improvementAreaBar: {
    height: 6,
    backgroundColor: '#E2E8F0',
    borderRadius: 3,
    marginBottom: 8,
    overflow: 'hidden',
  },
  improvementAreaFill: {
    height: '100%',
    backgroundColor: '#0e4e96',
    borderRadius: 3,
  },
  improvementAreaTip: {
    fontSize: 12,
    color: '#64748B',
    fontStyle: 'italic',
    marginTop: 4,
  },

  // Requests Tab
  requestsContainer: {
    flex: 1,
    padding: 16,
  },
  requestsHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  requestsTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#0F172A',
  },
  newRequestButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#0e4e96',
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 6,
  },
  newRequestButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#ffffff',
    marginLeft: 4,
  },
  requestsInfo: {
    flexDirection: 'row',
    backgroundColor: '#F1F5F9',
    borderRadius: 8,
    padding: 12,
    marginBottom: 24,
  },
  requestsInfoText: {
    flex: 1,
    fontSize: 14,
    color: '#64748B',
    marginLeft: 8,
    lineHeight: 20,
  },
  requestsListContainer: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 24,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  requestsListTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 16,
  },
  requestItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  requestItemIcon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#E0F2FE',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  requestItemContent: {
    flex: 1,
  },
  requestItemEmail: {
    fontSize: 14,
    fontWeight: '500',
    color: '#0F172A',
    marginBottom: 2,
  },
  requestItemDate: {
    fontSize: 12,
    color: '#64748B',
    marginBottom: 4,
  },
  requestItemStatus: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  requestItemStatusDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#10B981',
    marginRight: 4,
  },
  requestItemStatusText: {
    fontSize: 12,
    color: '#10B981',
  },
  requestItemStatusPending: {
    opacity: 0.8,
  },
  requestItemStatusDotPending: {
    backgroundColor: '#F59E0B',
  },
  requestItemStatusTextPending: {
    color: '#F59E0B',
  },
  requestItemRemind: {
    backgroundColor: '#F0F9FF',
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 6,
  },
  requestItemRemindText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#0e4e96',
  },
  requestTemplateContainer: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  requestTemplateTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 4,
  },
  requestTemplateSubtitle: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 16,
  },
  requestTemplatePreview: {
    backgroundColor: '#F8FAFC',
    borderRadius: 8,
    padding: 12,
    marginBottom: 16,
  },
  requestTemplatePreviewText: {
    fontSize: 14,
    color: '#334155',
    lineHeight: 20,
  },
  editTemplateButton: {
    backgroundColor: '#F1F5F9',
    paddingVertical: 10,
    borderRadius: 6,
    alignItems: 'center',
  },
  editTemplateButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#0e4e96',
  },

  // Floating Button
  floatingButton: {
    position: 'absolute',
    bottom: 20,
    right: 20,
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: '#0e4e96',
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 3,
    elevation: 3,
  },

  // Modals
  modalContainer: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'flex-end',
  },
  modalContent: {
    backgroundColor: '#ffffff',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '90%',
  },
  modalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  modalCloseButton: {
    padding: 4,
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#0F172A',
  },
  modalBody: {
    padding: 16,
    maxHeight: height * 0.8,
  },
  detailReviewHeader: {
    flexDirection: 'row',
    marginBottom: 16,
  },
  detailEmployerLogo: {
    width: 60,
    height: 60,
    borderRadius: 8,
    marginRight: 12,
  },
  detailReviewHeaderInfo: {
    flex: 1,
    justifyContent: 'center',
  },
  detailEmployerName: {
    fontSize: 18,
    fontWeight: '700',
    color: '#0F172A',
    marginBottom: 2,
  },
  detailProjectName: {
    fontSize: 16,
    color: '#0e4e96',
    marginBottom: 2,
  },
  detailReviewDate: {
    fontSize: 14,
    color: '#64748B',
  },
  detailReviewRating: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  detailRatingNumber: {
    fontSize: 24,
    fontWeight: '700',
    color: '#0F172A',
    marginRight: 12,
  },
  detailCategoryRatings: {
    backgroundColor: '#F8FAFC',
    borderRadius: 12,
    padding: 16,
    marginBottom: 20,
  },
  detailSectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 12,
  },
  detailCategoryRatingItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  detailCategoryLabel: {
    fontSize: 14,
    color: '#0F172A',
  },
  detailCategoryRatingValue: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  detailCategoryRatingNumber: {
    fontSize: 14,
    fontWeight: '600',
    color: '#0F172A',
    marginRight: 4,
  },
  detailReviewComment: {
    marginBottom: 20,
  },
  detailCommentText: {
    fontSize: 14,
    color: '#334155',
    lineHeight: 22,
  },
  detailReviewerInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F8FAFC',
    borderRadius: 12,
    padding: 12,
    marginBottom: 20,
  },
  detailReviewerPhoto: {
    width: 48,
    height: 48,
    borderRadius: 24,
    marginRight: 12,
  },
  detailReviewerName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 2,
  },
  detailReviewerPosition: {
    fontSize: 14,
    color: '#64748B',
  },
  detailResponseContainer: {
    marginBottom: 20,
  },
  detailResponseContent: {
    backgroundColor: '#F0F9FF',
    borderRadius: 12,
    padding: 16,
    borderLeftWidth: 3,
    borderLeftColor: '#0e4e96',
  },
  detailResponseText: {
    fontSize: 14,
    color: '#334155',
    lineHeight: 22,
    fontStyle: 'italic',
  },
  responseInputContainer: {
    marginBottom: 20,
  },
  responseInput: {
    backgroundColor: '#F8FAFC',
    borderRadius: 8,
    padding: 12,
    height: 120,
    textAlignVertical: 'top',
    fontSize: 14,
    color: '#334155',
    marginBottom: 12,
  },
  responseButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  cancelResponseButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    marginRight: 8,
  },
  cancelResponseButtonText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#64748B',
  },
  submitResponseButton: {
    backgroundColor: '#0e4e96',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 6,
  },
  submitResponseButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#ffffff',
  },
  addResponseButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0e4e96',
    paddingVertical: 12,
    borderRadius: 8,
    marginBottom: 20,
  },
  addResponseButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#ffffff',
    marginLeft: 8,
  },
  detailActionButtons: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    borderTopWidth: 1,
    borderTopColor: '#E2E8F0',
    paddingTop: 16,
  },
  detailActionButton: {
    alignItems: 'center',
  },
  detailActionButtonText: {
    fontSize: 12,
    color: '#64748B',
    marginTop: 4,
  },
  requestModalContent: {
    backgroundColor: '#ffffff',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    padding: 16,
  },
  requestModalBody: {
    padding: 16,
  },
  requestModalText: {
    fontSize: 14,
    color: '#334155',
    lineHeight: 20,
    marginBottom: 20,
  },
  requestInputContainer: {
    marginBottom: 20,
  },
  requestInputLabel: {
    fontSize: 14,
    fontWeight: '500',
    color: '#0F172A',
    marginBottom: 8,
  },
  requestInput: {
    backgroundColor: '#F8FAFC',
    borderRadius: 8,
    padding: 12,
    fontSize: 14,
    color: '#334155',
  },
  sendRequestButton: {
    backgroundColor: '#0e4e96',
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  sendRequestButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#ffffff',
  },

  // Context bar
  contextBar: {
    flexDirection: 'row',
    backgroundColor: '#ffffff',
    marginHorizontal: 20,
    marginTop: 12,
    borderRadius: 16,
    padding: 14,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.15)',
  },
  contextItem: { flex: 1 },
  contextLabel: { fontSize: 12, color: '#334155', fontWeight: '700' },
  contextValue: { fontSize: 18, color: '#0e4e96', fontWeight: '900', marginTop: 2 },
  contextHint: { fontSize: 11, color: '#64748b', marginTop: 2 },
  contextDivider: { width: 1, backgroundColor: '#e2e8f0', marginHorizontal: 12 },
  contextProgress: { height: 6, backgroundColor: '#e2e8f0', borderRadius: 999, overflow: 'hidden', marginTop: 6 },
  contextProgressFill: { height: 6, backgroundColor: '#fdb913' },

});
